// extracted by mini-css-extract-plugin
module.exports = {"responsiveInputContainer":"table-title_responsiveInputContainer__zf8_K"};